import React, { Component } from 'react';
import {FormattedMessage} from 'react-intl'
import './successful.css'
class Successful extends Component {
    state = {  }
    goToHome(){
        this.props.history.push('/Home');
    }
    render() { 
        return (<ul className="submitUl">
        <li>
            <img src="images/submitUl.png" alt=""/>
            <h4><FormattedMessage id="intl-succeedTitle"/></h4>
        </li>

        <li style={{"fontSize":"14px"}}><FormattedMessage id="intl-succeedTip"/><br/>
          <FormattedMessage id="intl-succeedTip2"/>
        </li>
        <li><a className='btn-hollow' onClick={this.goToHome.bind(this)}><FormattedMessage id='intl-backHome'/></a></li>
    </ul>);
    }
}
 
export default Successful;


// WEBPACK FOOTER //
// ./src/containers/Successful/index.jsx